export const SourceRemoveReasonTypeDetail = "unserviceableremovereasondetails";

export const TitleRemoveReasonTypeDetails = {
  list: "Remove Reason Detail List",
  edit: "Edit Remove Reason Detail",
  create: "Create Remove Reason Detail",
};
